import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import axios from 'src/api/Api';
import {
    INITIATE_PROXY_FAILURE,
    INITIATE_PROXY_SUCCESS,
    TERMINATE_PROXY_FAILURE,
    TERMINATE_PROXY_SUCCESS,
} from 'src/pages/more/pages/proxies/redux/action/actionTypes.js';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export function* initiateProxy(action) {
    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/impersonation/impersonate`;
    try {
        const result = yield axios({
            method: 'post',
            url: url,
            headers: {
                PrincipalUser: action.payload.user.networkId,
            },
        }).then((response) => response.data);
        sessionStorage.removeItem('proxyTerminationFlag');
        // sessionStorage.setItem('ProxyDistrict', action.payload.district);
        sessionStorage.setItem(
            'ProxyUserRole',
            action.payload.user.employeeRole
        );
        sessionStorage.setItem('proxyUserId', action.payload.user.networkId);

        sessionStorage.setItem(
            'ProxyimpersonationKey',
            result.impersonationKey
        );

        yield put({ type: INITIATE_PROXY_SUCCESS, payload: result });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload,
        });
        yield put({
            type: TERMINATE_PROXY_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}

export function* terminateProxy() {
    const ProxyKey = sessionStorage.getItem('ProxyimpersonationKey');

    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/impersonation/invalidate`;
    try {
        const result = yield axios({
            method: 'post',
            url: url,
            headers: {
                ImpersonationKey: ProxyKey,
            },
        }).then((response) => response.data);
        sessionStorage.removeItem('ProxyUser');
        sessionStorage.removeItem('ProxyUserRole');
        sessionStorage.removeItem('ProxyimpersonationKey');
        sessionStorage.setItem('proxyTerminationFlag', true);

        yield put({ type: TERMINATE_PROXY_SUCCESS, payload: result });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
        });
        yield put({
            type: INITIATE_PROXY_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
